import { useState } from 'react'
import AuthService from 'services/AuthService'
import { useSelector, useDispatch } from 'react-redux'
import { updateCredentials, clearCredentials } from 'store/AuthenticationSlice'
import { setProveidor, clearProveidor } from 'store/ProveidorSlice'
import { updateUser, clearUser } from 'store/UserSlice'

export const ROLES = {
  admin: 'admin',
  mod: 'mod',
  user: 'user',
}

function getEpochSeconds() {
  const date = new Date()
  const epochSeconds = Math.floor(date.getTime() / 1000)

  return epochSeconds
}

export const useAuthentication = () => {
  const storedCredentials = useSelector((state) => state.credentials)

  const now = getEpochSeconds()
  const { expiration } = storedCredentials

  const isAuthenticated = storedCredentials.token !== '' && Number(expiration) > now

  const dispatch = useDispatch()
  const [loading, setLoading] = useState(false)
  const [loginFailed, setFailed] = useState(false)

  const login = ({ username, password }) => {
    setLoading(true)

    AuthService.loginUser({ username, password })
      .then((result) => {
        const { data } = result
        const { credentials, proveidor, user } = data
        dispatch(updateCredentials(credentials))
        dispatch(setProveidor(proveidor))
        dispatch(updateUser(user))
      })
      .catch((error) => setFailed(true))
      .finally(setLoading(false))

    // AuthService.loginUser({ username, password })
    //   .then((loginResponse) => {
    //     const { credentials, proveidor, user } = loginResponse
    //     dispatch(UpdateCredentials(credentials))
    //     dispatch(setProveidor(proveidor))
    //     dispatch(setUser(user))
    //   })
    //   .catch((error) => {
    //     console.log(error)
    //   })
    //   .finally(setLoading(false))
  }

  const logout = () => {
    dispatch(clearCredentials())
    dispatch(clearProveidor())
    dispatch(clearUser())
  }

  const hasRole = (role) => {
    const { roles } = storedCredentials
    return roles.some((x) => x === role)
  }

  return { login, logout, hasRole, loading, isAuthenticated, loginFailed }
}
